import React, { useState } from 'react';

import InlineForm from '@plone/volto/components/manage/Form/InlineForm';

import ImageTextLinkView from './ImageTextLinkView';
import ImageTextLinkSchema from './ImageTextLinkSchema';

import linkSVG from '@plone/volto/icons/link.svg';


import {
  Icon,
  SidebarPortal, 
} from '@plone/volto/components';


const ImageTextLinkEdit = (props) => {
  const { selected, onChangeBlock, block, data, intl, openObjectBrowser, required, resetSubmitUrl } = props;
  // const [activeFilter, setActiveFilter] = useState(0);
  const editProps = {
    ...props,
    data: {
      ...props.data,
      hidden: false,
      editEnabled: true
    }
  }
  return (
    <div>
      <SidebarPortal selected={selected}>
        <InlineForm
            icon={<Icon size="24px" name={linkSVG} />}
            schema={ImageTextLinkSchema}
            title={ImageTextLinkSchema.title}
            headerActions={<button onClick={() => {}}>Action</button>}
            footer={<div></div>}
            onChangeField={(id, value) => {
              onChangeBlock(block, {
                ...data,
                [id]: value,
              });
            }}
            formData={data}
          />
          
       </SidebarPortal> 

       <ImageTextLinkView {...editProps} /> 
    </div>
  );
};

export default ImageTextLinkEdit;